// import React from "react";
// import {
//   Page,
//   Text,
//   View,
//   Document,
//   StyleSheet,
//   Image
// } from "@react-pdf/renderer";

// import PdfSecondPage from "./SecondImagePdf";
// import TechSpecs from "./TechSpecs";
// import TermsConditions from "./TermsandConditions";




// // Example image imports (replace with your actual files)
// import logo from "../images/Helix logo.jpg";
// import product1 from "../images/product1.jpg";
// import product2 from "../images/product2.jpg";
// import product3 from "../images/product3.jpg";

// // Sketch background images
// import sketch1 from "../images/sketch1.jpg";
// import sketch2 from "../images/sketch2.jpg";
// import sketch3 from "../images/sketch3.jpg";

// // Social media icons
// import instagram from "../images/instagram.jpeg";
// import youtube from "../images/youtube.png";
// import linkedin from "../images/web.jpeg";
// import BankDetailsPage from "./BankDetail";

// const Pdf2 = () => (
//   <Document>
//     <Page size="A4" style={styles.page}>
//       {/* Foreground Content */}
//       <View style={styles.content}>
//         {/* Header */}
//         <View style={styles.header}>
//           <Image src={logo} style={styles.logo} />
//           <View style={styles.headerRight}>
//             <Text style={styles.contact}>+91 8827559628 | info@sbsgroups.co.in</Text>
//             <Text style={styles.contact}>+91 9826808412 | sales@sbsgroups.co.in</Text>
//           </View>
//         </View>


//         {/* Quotation Table */}
// <View style={styles.tableContainer}>
//   <View style={styles.table}>
//     <View style={styles.tableRowHeader}>
//       <Text style={styles.tableHeaderText}>
//         Quotation for {initialQuotations.products[0]?.modelNo || "Product"}
//       </Text>
//     </View>

//     <View style={styles.tableRow}>
//       <Text style={styles.label}>Kindly attend to:</Text>
//       <Text style={styles.value}>{initialQuotations.customer.name}</Text>
//     </View>

//     <View style={styles.tableRow}>
//       <Text style={styles.label}>Contact No:</Text>
//       <Text style={styles.value}>{initialQuotations.customer.contact}</Text>
//     </View>

//     <View style={styles.tableRow}>
//       <Text style={styles.label}>Company Name:</Text>
//       <Text style={styles.value}>{initialQuotations.customer.company}, {initialQuotations.customer.address}</Text>
//     </View>

//     <View style={styles.tableRow}>
//       <Text style={styles.label}>Email Id:</Text>
//       <Text style={styles.value}>{initialQuotations.customer.email || "-"}</Text>
//     </View>

//     <View style={styles.tableRow}>
//       <Text style={styles.label}>GSTIN No:</Text>
//       <Text style={styles.value}>{initialQuotations.customer.gstin}</Text>
//     </View>

//     <View style={styles.tableRow}>
//       <Text style={styles.label}>Quo Ref No:</Text>
//       <Text style={styles.value}>{initialQuotations.quotationId}</Text>
//     </View>

//     {/* <View style={styles.tableRow}>
//       <Text style={styles.label}>Quotation Date:</Text>
//       <Text style={styles.value}>{initialQuotations.quotationDate}</Text>
//     </View> */}
//   </View>
// </View>


//         {/* Sketches in a row */}
//         <View style={styles.sketchesRow}>
//           <Image src={sketch1} style={styles.sketchImage} />
//           <Image src={sketch2} style={styles.sketchImage} />
//           <Image src={sketch3} style={styles.sketchImage} />
//         </View>

//         {/* Product Images */}
//         <View style={styles.imagesRow}>
//           <Image src={product1} style={styles.productImage} />
//           <Image src={product2} style={styles.productImage} />
//           <Image src={product3} style={styles.productImage} />
//         </View>

//         {/* Footer (flow content, not absolute) */}
//         <View style={styles.footer}>
//           <Text style={styles.footerTitle}>MODERN SOLUTION FOR HANDLING</Text>

//           <View style={styles.socialRow}>
//             <Image src={instagram} style={styles.icon} />
//             <Text style={styles.socialText}>helixengineers</Text>
//             <Image src={youtube} style={styles.icon} />
//             <Text style={styles.socialText}>HelixEngineers</Text>
//             <Image src={linkedin} style={styles.icon} />
//             <Text style={styles.socialText}>sbsgroups.co.in</Text>
//           </View>

//           <View style={styles.addressBar}>
//             <Text style={styles.footerAddress}>
//               Main Road Tali Waidhan, Near Honda Showroom, Singrauli M.P.-486886 (INDIA).
//             </Text>
//           </View>
//         </View>
//       </View>
//     </Page>
//      {/* Second Page */}
//      <PdfSecondPage />
//      {/* Third Page */}



// {initialQuotations.products.map((p, idx) => (
//   <TechSpecs key={p.id || idx} product={p} />
// ))}

// <TermsConditions products={initialQuotations} />

//      {/* Fourth Page */}
//      {/* <TermsConditions /> */}
//      {/* Fifth Page */}
//     <BankDetailsPage
//   bankDetails={initialQuotations.bankDetails}
//   legalCerts={initialQuotations.legalCerts}
//   preparedBy={initialQuotations.preparedBy}
//    regards={initialQuotations.regards}
// />


//   </Document>
// );

// const styles = StyleSheet.create({
//   page: {
//     padding: 20,
//     fontSize: 10,
//     fontFamily: "Helvetica",
//     backgroundColor: "#fff"
//   },
//   content: {
//     flexDirection: "column"
//   },
//   header: {
//     flexDirection: "row",
//     justifyContent: "space-between",
//     alignItems: "center",
//     marginBottom: 15
//   },
//   logo: {
//     width: 100,
//     height: 50
//   },
//   headerRight: {
//     flexDirection: "column",
//     alignItems: "flex-end"
//   },
//   contact: {
//     fontSize: 9
//   },
//   tableContainer: {
//     width: "50%", // table occupies 50% width
//     marginBottom: 20
//   },
//   table: {
//     border: "1pt solid #000"
//   },
//   tableRowHeader: {
//     backgroundColor: "#000",
//     padding: 5
//   },
//   tableHeaderText: {
//     color: "#fff",
//     fontSize: 11,
//     fontWeight: "bold"
//   },
//   tableRow: {
//     flexDirection: "row",
//     borderTop: "1pt solid #000",
//     padding: 5
//   },
//   label: {
//     width: "30%",
//     fontWeight: "bold"
//   },
//   value: {
//     width: "70%"
//   },
//   sketchesRow: {
//     flexDirection: "row",
//     justifyContent: "space-between",
//     marginVertical: 20
//   },
//   sketchImage: {
//     width: 120,
//     height: 100,
//     opacity: 2
//   },
//   imagesRow: {
//     flexDirection: "row",
//     justifyContent: "space-between",
//     marginVertical: 30 // ✅ extra space before footer
//   },
//   productImage: {
//     width: 180,
//     height: 250,
//     objectFit: "contain"
//   },
//   footer: {
//     marginTop: 20, // ✅ keeps footer away from images
//     textAlign: "center"
//   },
//   footerTitle: {
//     fontSize: 12,
//     fontWeight: "bold",
//     marginBottom: 10
//   },
//   socialRow: {
//     flexDirection: "row",
//     justifyContent: "center",
//     alignItems: "center",
//     marginBottom: 8
//   },
//   icon: {
//     width: 14,
//     height: 14,
//     marginHorizontal: 4
//   },
//   socialText: {
//     fontSize: 9,
//     marginRight: 10
//   },
//   addressBar: {
//     backgroundColor: "#222",
//     padding: 5,
//     marginTop: 5
//   },
//   footerAddress: {
//     fontSize: 9,
//     color: "#fff"
//   }
// });

// export default Pdf2;


import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image
} from "@react-pdf/renderer";

import PdfSecondPage from "./SecondImagePdf";
import TechSpecs from "./TechSpecs";
import TermsConditions from "./TermsandConditions";



// Example image imports (replace with your actual files)
import logo from "../../../images/Final-logo-SBS.png";
import product1 from "../images/product1.jpg";
import product2 from "../images/product2.jpg";
import product3 from "../images/product3.jpg";

// Sketch background images
import sketch1 from "../images/sketch1.jpg";
import sketch2 from "../images/sketch2.jpg";
import sketch3 from "../images/sketch3.jpg";

// Social media icons
import instagram from "../images/instagram.jpeg";
import youtube from "../images/youtube.png";
import linkedin from "../images/web.jpeg";
import BankDetailsPage from "./BankDetail";
import baseURL from "../../../Apiurs/Apiurls";

const Pdf2 = ({ data, quotationNumber, leadInfo, quotationData, discount, discountType, companyInfo, regardsInfo }) => {
  console.log("Lead Info in Pdf2:", leadInfo);
  console.log("Quotation Data in Pdf2:", quotationData);

  // Filter products that have images
  const productsWithImages = quotationData?.filter(item => item.product_image) || [];
  
  // Get first 6 products with images for display
  const displayedProducts = productsWithImages.slice(0, 6);

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Foreground Content */}
        <View style={styles.content}>
          {/* Header */}
          <View style={styles.header}>
            <Image src={logo} style={styles.logo} />
            <View style={styles.headerRight}>
              <Text style={styles.contact}>+91 8827559628 | info@sbsgroups.co.in</Text>
              <Text style={styles.contact}>+91 9826808412 | sales@sbsgroups.co.in</Text>
            </View>
          </View>

          {/* Quotation Table */}
          <View style={styles.tableContainer}>
            <View style={styles.table}>
              <View style={styles.tableRowHeader}>
                <Text style={styles.tableHeaderText}>Quotation</Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.label}>Kindly attend to:</Text>
                <Text style={styles.value}>{leadInfo?.lead_name || "N/A"}</Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.label}>Contact No:</Text>
                <Text style={styles.value}>{leadInfo?.contact_number || "N/A"}</Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.label}>Company Name:</Text>
                <Text style={styles.value}>{leadInfo?.bussiness_name || "N/A"}</Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.label}>Email Id:</Text>
                <Text style={styles.value}>{leadInfo?.email || "N/A"}</Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.label}>GSTIN No:</Text>
                <Text style={styles.value}>{leadInfo?.gstin_lead || "N/A"}</Text>
              </View>

              <View style={styles.tableRow}>
                <Text style={styles.label}>Quo Ref No:</Text>
                <Text style={styles.value}>{quotationNumber}</Text>
              </View>
            </View>
          </View>

          {/* Dynamic Product Images */}
          <View style={styles.productImagesContainer}>
            <Text style={styles.productImagesTitle}>Product Images</Text>
            
            {displayedProducts.length > 0 ? (
              <View style={styles.productImagesRow}>
                {displayedProducts.map((product, index) => (
                  <View key={index} style={styles.productImageWrapper}>
                     <Image 
                    src={`${baseURL}/Uploads/products/${product.product_image}`}
                    style={styles.dynamicProductImage}
                  />
                    <Text style={styles.productName}>
                      {product.product_name || `Product ${index + 1}`}
                    </Text>
                  </View>
                ))}
              </View>
            ) : (
              <Text style={styles.noImagesText}>
                No product images available
              </Text>
            )}
          </View>

          {/* Footer */}
          <View style={styles.footer}>
            <Text style={styles.footerTitle}>MODERN SOLUTION FOR HANDLING</Text>

            <View style={styles.socialRow}>
              <Image src={instagram} style={styles.icon} />
              <Text style={styles.socialText}>sbs</Text>
              <Image src={youtube} style={styles.icon} />
              <Text style={styles.socialText}>sbs</Text>
              <Image src={linkedin} style={styles.icon} />
              <Text style={styles.socialText}>sbs.in</Text>
            </View>

            <View style={styles.addressBar}>
              <Text style={styles.footerAddress}>
                Main Road Tali Waidhan, Near Honda Showroom, Singrauli M.P.-486886 (INDIA).
              </Text>
            </View>
          </View>
        </View>
      </Page>
      
      {/* Second Page */}
      <PdfSecondPage leadInfo={leadInfo} />
      
      {/* Third Page */}
      <TechSpecs quotationData={quotationData} />
      
      {/* Fourth Page */}
      <TermsConditions 
        leadInfo={leadInfo} 
        quotationData={quotationData} 
        data={data} 
        discount={discount} 
        discountType={discountType} 
      />
      
      {/* Fifth Page */}
      <BankDetailsPage companyInfo={companyInfo} regardsInfo={regardsInfo}/>
    </Document>
  );
};

const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 10,
    fontFamily: "Helvetica",
    backgroundColor: "#fff"
  },
  content: {
    flexDirection: "column"
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 15
  },
  logo: {
    width: 100,
    height: 50
  },
  headerRight: {
    flexDirection: "column",
    alignItems: "flex-end"
  },
  contact: {
    fontSize: 9
  },
  tableContainer: {
    width: "50%",
    marginBottom: 20
  },
  table: {
    border: "1pt solid #000"
  },
  tableRowHeader: {
    backgroundColor: "#000",
    padding: 5
  },
  tableHeaderText: {
    color: "#fff",
    fontSize: 11,
    fontWeight: "bold"
  },
  tableRow: {
    flexDirection: "row",
    borderTop: "1pt solid #000",
    padding: 5
  },
  label: {
    width: "30%",
    fontWeight: "bold"
  },
  value: {
    width: "70%"
  },
  // Dynamic product images styles
  productImagesContainer: {
    marginVertical: 20
  },
  productImagesTitle: {
    fontSize: 12,
    fontWeight: "bold",
    marginBottom: 10,
    textAlign: "center"
  },
  productImagesRow: {
    flexDirection: "row",
    justifyContent: "space-around",
    flexWrap: "wrap",
    marginBottom: 10
  },
  productImageWrapper: {
    alignItems: "center",
    margin: 5,
    width: "30%"
  },
  dynamicProductImage: {
    width: 80,
    height: 80,
    objectFit: "cover",
    marginBottom: 5,
    border: "1pt solid #ddd"
  },
  productName: {
    fontSize: 8,
    textAlign: "center",
    maxWidth: 80
  },
  noImagesText: {
    fontSize: 10,
    textAlign: "center",
    color: "#666",
    fontStyle: "italic",
    marginVertical: 20
  },
  footer: {
    marginTop: 20,
    textAlign: "center"
  },
  footerTitle: {
    fontSize: 12,
    fontWeight: "bold",
    marginBottom: 10
  },
  socialRow: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 8
  },
  icon: {
    width: 14,
    height: 14,
    marginHorizontal: 4
  },
  socialText: {
    fontSize: 9,
    marginRight: 10
  },
  addressBar: {
    backgroundColor: "#222",
    padding: 5,
    marginTop: 5
  },
  footerAddress: {
    fontSize: 9,
    color: "#fff"
  }
});

export default Pdf2;
